import { ProgressBarController } from '../../../../common/ui/progressBar/progressBar.controller';
import _ from 'lodash';

export class StatusProgressBarController extends ProgressBarController {
  $onInit() {
    this.setStateIndex();
    this.showProgressBar = true;
  }

  $onChanges() {
    this.setStateIndex();
  }

  setStateIndex() {
    this.currentStateIndex = _.findIndex(this.states, {
      stateName: this.activeState,
    });
    this.lastStateIndex = 2;
  }

  getStateStyle(state = this.activeState, index = this.currentStateIndex) {
    const { currentStateIndex } = this;

    state.completed = index <= currentStateIndex;
    state.disabled = !state.completed;
    state.style = this.progressItemStyle;
    state.type = state.disabled ? 'text' : 'link';
    state.status = state.isLink ? '' : 'disabled';

    return state.style;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/status/components/progressBar/progressBar.controller.js